import { Post } from "../app_services/ApiService";
import { Loading, AlertError, AlertInfo, AlertClose, AlertWarning } from "../app_services/AlertService";

export const get_point_balance_store_by_mobile = async (form, setData) => {
    try {
        Loading()
        let respon = await Post(`mkmedical-api/customer/reward-customer-line-account/get-point-balance-store-by-mobile`, form);
        if (respon.status !== 200) {
            AlertError();
            return;
        }
        if (respon.data.status !== '1') {
            AlertWarning(respon.data.message)
            return;
        }
        setData(respon.data.data)
        AlertClose();

        return true
    } catch (error) {
        console.log(error)
        AlertError();
    }
};

